import { render, staticRenderFns } from "./CategoryTabImages.vue?vue&type=template&id=18407c6a&scoped=true"
import script from "./CategoryTabImages.vue?vue&type=script&lang=ts"
export * from "./CategoryTabImages.vue?vue&type=script&lang=ts"
import style0 from "./CategoryTabImages.vue?vue&type=style&index=0&id=18407c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18407c6a",
  null
  
)

export default component.exports